import type { FieldProvenanceDto, MissionAssessmentTechnologyUseSelectDto } from '@@types/api.types';
import { BlueLabel } from '@components/shared/blue-label.component';
import { FieldProvenanceBadge } from '@components/shared/field-provenance-badge.component';
import { provenanceItemKeys } from '@utils/mission-assessment-provenance.util';
import type { FunctionComponent } from 'react';

type TechnologyMissionAssessmentRecommendedTechUsesProps = {
  provenance?: Record<string, FieldProvenanceDto> | null;
  recommendedTechnologyUses: MissionAssessmentTechnologyUseSelectDto[];
};

export const TechnologyMissionAssessmentRecommendedTechUses: FunctionComponent<
  TechnologyMissionAssessmentRecommendedTechUsesProps
> = (props) => {
  const { provenance, recommendedTechnologyUses } = props;

  if (recommendedTechnologyUses.length === 0) {
    return (
      <div className="mt-6 flex flex-col items-start gap-4 w-full">
        <div className="flex flex-col items-start gap-2 w-full">
          <h3 className="text-base text-gray-700">Recommended Technology Uses</h3>
          <p className="text-xs text-gray-500">No data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-6 flex flex-col items-start gap-4 w-full">
      <div className="flex flex-col items-start gap-2 w-full">
        <h3 className="text-base text-gray-700">Recommended Technology Uses</h3>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 w-full">
          {recommendedTechnologyUses.map((techUse) => {
            const useName = techUse.use?.name || 'Unknown Use';
            const domainNames = techUse.domains?.map((d) => d.name).filter(Boolean) || [];
            const itemProvenance = techUse.use?.id
              ? provenance?.[provenanceItemKeys.technologyUse(techUse.use.id)]
              : null;

            return (
              <div
                className="rounded-lg border border-gray-200 bg-white p-3"
                key={techUse.id}
              >
                <div className="flex items-start gap-3">
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <div className="truncate text-sm font-medium text-gray-600">{useName}</div>
                      <FieldProvenanceBadge provenance={itemProvenance} />
                    </div>
                    <BlueLabel text="Use" />

                    {domainNames.length > 0 ? (
                      <div className="mt-2 flex flex-wrap gap-2 text-sm text-gray-600">{domainNames.join(', ')}</div>
                    ) : (
                      <div className="mt-2 text-xs text-gray-500">No domains selected</div>
                    )}
                    <BlueLabel text="Domains" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
